import React, { useEffect, useState } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';
const backendURL = process.env.REACT_APP_BACKEND_URL;

function ServiceCategories() {
  const [data, setData] = useState(false);
  const [data1, setData1] = useState(false);
  const [pageData, setPageData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <IconField iconPosition="right">
        <InputIcon className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
      </IconField>
    </div>
  );

  const handleClose = () => setShowModal(false);

  const ChangeStatus = async (options, e) => {
    options.editorCallback(e.target.value);
    try {
      const response = await axios.post("/action/changeStatus", { type: 'category', key: e.target.name, value: e.target.value, id: options.rowData._id });
      const { status, message, data } = response.data;
      if (status) {
        toast(message);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const fetchData = async (event) => {
    let rechargeData = {
      first: event.first,
      rows: event.rows,
      //type: pageData.type,
      //start_date: pageData.start_date,
      //end_date: pageData.end_date,
    };
    getData(rechargeData);
  };

  const getData = async (requestData = {}) => {
    try {
      setLoading(true);
      const response = await axios.post("/history/serviceCategories", requestData);
      const { status, data, first, rows, totalRecords } = response.data;
      if (status) {
        setData(response.data);
        setPageData({ first, rows, totalRecords });
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const onCellEditComplete = (e) => {
    let { rowData, newValue, field, originalEvent: event } = e;
    if (newValue.trim().length > 0) rowData[field] = newValue;
    else event.preventDefault();
  };

  const cellEditor = (options) => {
    return (
      <select name="status" value={options.value} onChange={(e) => ChangeStatus(options, e)} onKeyDown={(e) => e.stopPropagation()}>
        <option value="Active">Active</option>
        <option value="Inactive">Inactive</option>
      </select>
    );
  };

  const viewPackages = async (category_id) => {
    try {
      const response = await axios.post("/history/serviceProviders1", { category_id });
      const { status, data, totalRecords } = response.data;
      if (status) {
        setData1(response.data.data);
        setShowModal(true);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              {
                data && (
                  <>
                    <h4 class="card-title">
                      Categories
                    </h4>
                    <DataTable
                      value={data.data}
                      size="small"
                      editMode="cell"
                      globalFilter={globalFilter}
                      header={header}
                      className="custom-table" // Add custom class here
                      loading={loading}
                    >
                      <Column
                        field="index"
                        header="#"
                        sortable
                        body={(rowData, { rowIndex }) => <span data-label="#">{pageData?.first + rowIndex + 1}</span>}
                      />
                      <Column
                        field="created_at"
                        header="Date"
                        sortable
                        body={(rowData) => <span data-label="Date">{moment(rowData.created_at).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</span>}
                      />
                      <Column
                        field="category_name"
                        header="Category Name"
                        sortable
                        body={(rowData) => <span data-label="CategoryName">{rowData?.category_name}</span>}
                      />
                      <Column
                        field="type"
                        header="Type"
                        sortable
                        body={(rowData) => <span data-label="Type">{rowData.type}</span>}
                      />
                      <Column
                        field="image"
                        header="Image"
                        sortable
                        body={(rowData) => <span data-label="Image" className="servicesLogo"><img src={backendURL + "/" + rowData?.image} /></span>}
                      />
                      <Column
                        field="status"
                        header="Status"
                        sortable
                        body={(rowData) => <span data-label="Status">{rowData?.status}</span>}
                        editor={(options) => cellEditor(options)}
                        onCellEditComplete={onCellEditComplete}
                      />
                      <Column
                        field="action"
                        header="Action"
                        sortable
                        body={
                          (rowData) => (
                            <span data-label="Action">
                              <button className="btn btn-primary" onClick={(e) => viewPackages(rowData?._id)}>View</button>
                            </span>
                          )
                        }
                      />
                    </DataTable>
                    <div className="card">
                      <Paginator first={pageData && pageData.first} rows={pageData && pageData.rows} totalRecords={pageData && pageData.totalRecords} rowsPerPageOptions={[5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000]} onPageChange={fetchData} />
                    </div>
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
      {/* Modal component */}
      <Modal show={showModal} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Providers Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {
              data1 && (
                <table class="table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Category Name</th>
                      <th>Provider Name</th>
                      <th>Image</th>
                      <th>Status</th>
                      <th>Recharge By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      data1.map((rowData) => (
                        <tr>
                          <td>{moment(rowData.created_at).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</td>
                          <td>{rowData?.category_id?.category_name}</td>
                          <td>{rowData?.provider_name}</td>
                          {/* <td>{rowData.image}</td> */}
                          <td><span data-label="Image" className="servicesLogo"><img src={backendURL + "/" + rowData?.image} /></span></td>
                          <td>{rowData.status}</td>
                          <td>{rowData.rechargeBy}</td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              )
            }
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ServiceCategories;
